import React from 'react';
import { Box, Typography, Paper, Stack, Button } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Check } from '@mui/icons-material';
import { SiteImportResponse } from '../../../api/sitesApi';

interface ImportSuccessStepProps {
  importResult: SiteImportResponse;
  onViewSite: () => void;
}

const ImportSuccessStep: React.FC<ImportSuccessStepProps> = ({
  importResult,
  onViewSite,
}) => {
  const summaryRows = [
    { label: 'Site name', value: importResult.siteName },
    { label: 'Site code', value: importResult.slug },
    { label: 'Plots', value: importResult.plotCount.toLocaleString() },
    {
      label: 'Labour items',
      value: importResult.labourItemCount.toLocaleString(),
    },
    {
      label: 'Total value',
      value: new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
      }).format(importResult.totalValue),
    },
  ];

  return (
    <Box data-testid="import-success-step">
      <Stack spacing={3} alignItems="center">
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />

        <Box textAlign="center">
          <Typography variant="h5" fontWeight={600}>
            Site created!
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Your site is ready to go.
          </Typography>
        </Box>

        <Paper variant="outlined" sx={{ p: 3, borderRadius: 2, width: '100%' }}>
          <Stack spacing={1.5}>
            {summaryRows.map(row => (
              <Box
                key={row.label}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  {row.label}
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                  {row.value}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Paper>

        <Button
          variant="outlined"
          color="success"
          startIcon={<Check />}
          onClick={onViewSite}
          sx={{ fontWeight: 700, px: 4 }}
          data-testid="import-success-view-site-button"
        >
          View Site
        </Button>
      </Stack>
    </Box>
  );
};

export default ImportSuccessStep;
